import { render, staticRenderFns } from "./bigDividendRule.vue?vue&type=template&id=12ffff40&scoped=true&"
import script from "./bigDividendRule.vue?vue&type=script&lang=js&"
export * from "./bigDividendRule.vue?vue&type=script&lang=js&"
import style0 from "./bigDividendRule.vue?vue&type=style&index=0&id=12ffff40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ffff40",
  null
  
)

export default component.exports